import { Component, OnDestroy, OnInit } from '@angular/core';
import { UnreadChannelMessage } from '../../model/unread-channel-message';
import { ChatService } from '../../service/chat.service';
import { sumBy } from 'lodash';
import { ChannelService } from '../../service/channel.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnDestroy, OnInit {

  private isChatVisible: boolean = false;

  get visible(): boolean {
    return this.isChatVisible;
  }

  set visible(isVisible: boolean) {
    this.chatService.setVisibility(this.isChatVisible = isVisible);
  };

  unreadMessageCount: UnreadChannelMessage[];

  constructor(private chatService: ChatService, private channelService: ChannelService) {}

  ngOnInit(): void {
    this.channelService.getUnreadObservable().subscribe(data => this.unreadMessageCount = data);
    this.chatService.init();
  }

  ngOnDestroy(): void {
    this.chatService.unsubscribeData();
    this.channelService.unsubscribeData();
  }

  getUnreadSum(): number {
    return sumBy(this.unreadMessageCount, 'unread');
  }
}
